class CustomHeader extends HTMLElement {
  constructor() {
    super();
    this.headerMain = this.querySelector('.custom-header__main');
    this.announcement = this.querySelector('.custom-header__announcement');
    this.nav = this.querySelector('[data-nav]');
    this.mobileMenu = this.querySelector('[data-mobile-menu]');
    this.burger = this.querySelector('[data-burger]');
    this.spacer = this.querySelector('[data-header-spacer]');
    this.offset = 0;
    this.isSticky = false;
  }

  connectedCallback() {
    this.offset = this.announcement.offsetHeight;
    this.initNav();
    this.initSticky();
    this.initMobileMenu();
  }

  initNav() {

    // Obtener los elementos y mapearlos con su orden
    const items = Array.from(document.querySelectorAll('[data-nav-tab-title]'));
    const navItems = items.map(el => {
      let order = el.dataset.navTabOrder;
      order = order !== undefined && !isNaN(Number(order)) ? Number(order) : null;
      return { el, order };
    });

    // Separar los que tienen orden numérico y los que no
    const withOrder = navItems.filter(item => item.order !== null).sort((a, b) => a.order - b.order);
    const withoutOrder = navItems.filter(item => item.order === null);
    const sortedItems = [...withOrder, ...withoutOrder];

    // Imprimir en el orden correcto
    sortedItems.forEach(({ el }) => {
      const title = el.dataset.navTabTitle;
      const link = "#" + el.dataset.navTabLink;

      const a = document.createElement('a');
      a.textContent = title;
      a.href = link;

      a.classList.add('custom-header__nav-link');
      a.addEventListener('click', e => {
        e.preventDefault();
        this.scrollToSection(link);
      });

      this.nav.appendChild(a);

      const mobileLink = a.cloneNode(true);

      mobileLink.addEventListener('click', e => {
        e.preventDefault();
        this.scrollToSection(link);
        this.closeMobileMenu();
      });
      
      this.mobileMenu.appendChild(mobileLink);
    });

    const last_title = "Shop All Sports Bras";
    const last_link = "/collections/all-sports-bras";

    const last_a = document.createElement('a');
    last_a.textContent = last_title;
    last_a.href = last_link;
    last_a.classList.add('custom-header__nav-link');

    this.nav.appendChild(last_a);

    const last_mobileLink = last_a.cloneNode(true);
    this.mobileMenu.appendChild(last_mobileLink);
  }

  closeMobileMenu() {
    this.mobileMenu.classList.remove('active');
    this.burger.classList.remove('active');
    document.body.style.overflow = '';
  }

  toggleBurger() {
    const isOpen = this.mobileMenu.classList.toggle('active');

    this.burger.classList.toggle('active', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';

    if (isOpen && this.isSticky) {
      this.updateMobileMenuPosition();
    }
  }

  initSticky() {
    window.addEventListener('scroll', () => {
      const headerHeight = this.headerMain.offsetHeight;

      if (window.scrollY >= this.offset) {
        if (!this.isSticky) {
          this.isSticky = true;
          this.headerMain.classList.add('custom-header__sticky');
          this.spacer.style.height = `${headerHeight}px`;

          this.updateMobileMenuPosition();
        }
      } else {
        if (this.isSticky) {
          this.isSticky = false;
          this.headerMain.classList.remove('custom-header__sticky');
          this.spacer.style.height = '0px';

          this.mobileMenu.style.top = '';
        }
      }
    });
  }

  initMobileMenu() {
    this.burger.addEventListener('click', () => {
      this.toggleBurger();
    });
  }

  updateMobileMenuPosition() {
    const headerHeight = this.headerMain.offsetHeight;
    this.mobileMenu.style.top = `${headerHeight}px`;
  }

  scrollToSection(selector) {
    const target = document.querySelector(selector);
    if (!target) return;

    const headerHeight = this.headerMain.offsetHeight;

    const y =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }
}

customElements.define('custom-header', CustomHeader);